import { defaultMacroOpen, type CrmDealMacroId } from './crmDealStagePresets';
import type { SalesStage } from '../../../api';

export type CrmDrawerMacroState = Record<CrmDealMacroId, boolean>;

const KEY_PREFIX = 'crm:drawer:expanded:';

export function crmDrawerStorageKey(dealId: string): string {
  return `${KEY_PREFIX}${dealId}`;
}

export function loadCrmDrawerMacroState(dealId: string): Partial<CrmDrawerMacroState> | null {
  try {
    const raw = localStorage.getItem(crmDrawerStorageKey(dealId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CrmDrawerMacroState>;
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}

export function saveCrmDrawerMacroState(dealId: string, state: CrmDrawerMacroState): void {
  try {
    localStorage.setItem(crmDrawerStorageKey(dealId), JSON.stringify(state));
  } catch {
    /* quota / private mode */
  }
}

export function resolveInitialDrawerMacros(
  _dealId: string,
  stage: SalesStage,
  opts: { productionRead: boolean; isLead: boolean; forceComposeOpen?: boolean },
): CrmDrawerMacroState {
  const preset = defaultMacroOpen(stage, {
    productionRead: opts.productionRead,
    isLead: opts.isLead,
  });
  if (opts.forceComposeOpen) return { ...preset, compose: true };
  return preset;
}
